/** @jsxImportSource @emotion/react */
import { ButtonIcon } from "@coreai/component-library";
import React, { useState } from "react";
import { css, useTheme } from "@emotion/react";
import EditAnalyseDialog from "./EditAnalyseDialog";

interface EditAnalyseProps {
  analyse: any;
  onDelete: (analysisId: string) => void;
  onEdit: (analysisId: string, updatedAnalysis: any) => void;
  onDialogOpen: (id: string) => void;
  onDialogClose: () => void;
}

export default function EditAnalyse(props: Readonly<EditAnalyseProps>) {
  const [showAlertDialog, setShowAlertDialog] = useState(false);
  const theme = useTheme();

  const onDelete = (event: React.MouseEvent) => {
    event.stopPropagation();
    props.onDelete(props.analyse.id);
  };
  const onEdit = (event: React.MouseEvent) => {
    event.stopPropagation();   
    setShowAlertDialog(true);
    props.onDialogOpen(props.analyse.id);
  };

  const onCloseDialog = () => {
    setShowAlertDialog(false);
    props.onDialogClose();
  };

  const buttonStyle = () => css`
    color: ${theme.colors.primary};
    &:hover {
      border-color: ${theme.colors.white};
      background-color: ${theme.colors.white};
      color: ${theme.colors.primary};
    }
  `;

  return (
    <div style={{ display: "flex" }}>     
      <ButtonIcon
        name="editButton"
        variant={"secondary"}
        size="sm"
        icon={"edit-01"}
        onClick={onEdit}
        css={buttonStyle}
      />
      <ButtonIcon
        name="deletButton"
        variant={"secondary"}
        size="sm"
        icon={"trash"}
        onClick={onDelete}
        css={buttonStyle}
      />
      {
        showAlertDialog && (
          <EditAnalyseDialog
            analyse={props.analyse}
            open={showAlertDialog}
            onClose={onCloseDialog}
            onEdit={props.onEdit}
          />
        )
      }
    </div>
  );
}
